import { Button, Modal } from "react-bootstrap";
import { translateString } from "../../translations/gridTranslationHelper";
import { AplError } from "../../types/aplError";
import { Culture } from "../../types/culture";

interface ModalErrorProps {
    aplError: AplError | null;
    culture: Culture;
    okCallback: () => void;
}

const ModalError: React.FC<ModalErrorProps> = ({ aplError, culture, okCallback }) => {
    if (!aplError) return null;

    return (
        <div className="modal show fade" style={{ display: "block", position: "absolute" }}>
            <Modal.Dialog centered={true}>
                <Modal.Header closeButton={false}>
                    <Modal.Title>{translateString("error", culture)}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>{aplError.detail}</p>
                </Modal.Body>

                <Modal.Footer>
                    {/* <Button variant="secondary">Close</Button> */}
                    <Button variant="primary" onClick={okCallback}>
                        {translateString("close", culture)}
                    </Button>
                </Modal.Footer>
            </Modal.Dialog>
        </div>
    );
};

export default ModalError;
